import React from "react";
import { Panel } from "@myhealth-raccoon/components";

import { useAppointmentTypeSelector, useClinicSelector } from "src/hooks/useAsyncSelector";
import { innerHtml } from "src/utils/html";
import { isAfterHours } from "src/utils/appointmentTypes";
import { AfterHoursPricingDetails } from "./AfterHoursPricingDetails";

type Props = {
    isOpen: boolean,
    setOpen(open: boolean): void
}
export function CancellationPolicyDrawer({ isOpen, setOpen }: Props) {
    const { data: clinic } = useClinicSelector();
    const { data: appointmentType } = useAppointmentTypeSelector();

    return <Panel attachedTo="bottom" open={isOpen} setOpen={setOpen}
        title={<h2 className="px-2 py-3 text-lg text-gray-900 font-semibold">Pricing and Cancellation Info</h2>}
    >
        <hr />
        {appointmentType && isAfterHours(appointmentType) ?
            <div className="p-4 text-sm">
                <AfterHoursPricingDetails appointmentType={appointmentType} />
                <hr className="my-4" />
                This is a private service. You will not receive any Medicare Rebates for this consultation.
            </div>
            : <>
                <div className="p-4 text-sm">
                    <h3 className="text-gray-900 text-base font-semibold mb-1">Pricing details</h3>

                    <div className="space-y-2.5 text-gray-700">
                        <p>
                            Full payment is required at consultation. If applicable, the Medicare rebate will be processed onsite.
                        </p>
                        <p>
                            A surcharge of 1.28% + 35c applies for card payments.
                        </p>
                        <p>
                            <strong className="font-semibold">For detailed fee policy, view the <a target="_blank" className="text-primary" href={`${import.meta.env.VITE_MYHEALTH_WEBSITE}${clinic?.url}#pricing`}>centre's pricing policy</a>.</strong>
                        </p>
                    </div>
                </div>
                {clinic?.cancellationPolicyHtml && <>
                    <hr />
                    <div className="p-4 prose-sm text-gray-700" {...innerHtml(clinic.cancellationPolicyHtml)} />
                </>}
            </>}

    </Panel>
}